import { createEnv } from "@t3-oss/env-nextjs";
import * as z from "zod";

export const env = createEnv({
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  /*
   * Serverside Environment variables, not available on the client.
   * Will throw if you access these variables on the client.
   */
  server: {
    APOLLO_URL: z.string().min(1),
    BUGSNAG_RELEASE_STAGE: z.string().optional(),
    DRUPAL_SECRET: z.string().min(1),
    FACEBOOK_CLIENT_ID: z.string().optional(),
    FACEBOOK_CLIENT_SECRET: z.string().optional(),
    LINKEDIN_CLIENT_ID: z.string().optional(),
    LINKEDIN_CLIENT_SECRET: z.string().optional(),
    NEXTAUTH_SECRET: z.string().optional(),
    NEXTAUTH_URL: z.string().optional(),
    WORK_ID_CLIENT_ID: z.string().optional(),
    WORK_ID_ISSUER: z.string().optional(),
    ZERO_BOUNCE_API_KEY: z.string().optional(),
  },
  /*
   * Environment variables available on the client (and server).
   *
   * 💡 You'll get type errors if these are not prefixed with NEXT_PUBLIC_.
   */
  client: {
    NEXT_PUBLIC_BASE_URL: z.string().min(1),
    NEXT_PUBLIC_BUGSNAG_API_KEY: z.string().optional(),
    NEXT_PUBLIC_DRUPAL_DOMAIN: z.string().min(1),
    NEXT_PUBLIC_CHARLOTTE_CHAT_BASE_URL: z.string().min(1),
    NEXT_PUBLIC_GMAPS_API_KEY: z.string().optional(),
    NEXT_PUBLIC_GTM_CODE: z.string().optional(),
    NEXT_PUBLIC_TESTING_MODE: z.string().optional(),
  },
  /*
   * Due to how Next.js bundles environment variables on Edge and Client,
   * we need to manually destructure them to make sure all are included in bundle.
   *
   * 💡 You'll get type errors if not all variables from `server` & `client` are included here.
   */
  runtimeEnv: {
    APOLLO_URL: process.env.APOLLO_URL,
    BUGSNAG_RELEASE_STAGE: process.env.BUGSNAG_RELEASE_STAGE,
    DRUPAL_SECRET: process.env.DRUPAL_SECRET,
    FACEBOOK_CLIENT_ID: process.env.FACEBOOK_CLIENT_ID,
    FACEBOOK_CLIENT_SECRET: process.env.FACEBOOK_CLIENT_SECRET,
    LINKEDIN_CLIENT_ID: process.env.LINKEDIN_CLIENT_ID,
    LINKEDIN_CLIENT_SECRET: process.env.LINKEDIN_CLIENT_SECRET,
    NEXTAUTH_SECRET: process.env.NEXTAUTH_SECRET,
    NEXTAUTH_URL: process.env.NEXTAUTH_URL,
    WORK_ID_CLIENT_ID: process.env.WORK_ID_CLIENT_ID,
    WORK_ID_ISSUER: process.env.WORK_ID_ISSUER,
    ZERO_BOUNCE_API_KEY: process.env.ZERO_BOUNCE_API_KEY,
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    NEXT_PUBLIC_BUGSNAG_API_KEY: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
    NEXT_PUBLIC_CHARLOTTE_CHAT_BASE_URL:
      process.env.NEXT_PUBLIC_CHARLOTTE_CHAT_BASE_URL,
    NEXT_PUBLIC_DRUPAL_DOMAIN: process.env.NEXT_PUBLIC_DRUPAL_DOMAIN,
    NEXT_PUBLIC_GMAPS_API_KEY: process.env.NEXT_PUBLIC_GMAPS_API_KEY,
    NEXT_PUBLIC_GTM_CODE: process.env.NEXT_PUBLIC_GTM_CODE,
    NEXT_PUBLIC_TESTING_MODE: process.env.NEXT_PUBLIC_TESTING_MODE,
  },
});
